export default "__VITE_ASSET__DE1l6t8g__"